
function initMarquee(options) {
    var $wrap = $(options.wrap);
    var $track = $wrap.find(options.track);
    var $group = $track.find(options.group).eq(0);

    var speed = options.speed || 1;
    var x = 0;
    var groupWidth = 0;
    var isPaused = false;

    // 自动复制一组（防止忘写）
    if ($track.find(options.group).length === 1) {
        $group.clone().appendTo($track);
    }

    function updateWidth() {
        groupWidth = $group.outerWidth(true);
    }

    function animate() {
        if (!isPaused) {
            x -= speed;

            if (Math.abs(x) >= groupWidth) {
                x = 0;
            }

            $track.css("transform", "translate3d(" + x + "px,0,0)");
        }

        requestAnimationFrame(animate);
    }

    // hover暂停
    $wrap.hover(
        function () { isPaused = true; },
        function () { isPaused = false; }
    );

    $(window).on("load resize", updateWidth);

    updateWidth();
    animate();
}

var wFlag = window.innerWidth > 750
$(() => {
    new Swiper('.box1Swiper', {
        autoplay: true,
        loop: true,
        pagination: {
            el: '.box1Swiper-pagination',
            clickable: true,
        },
    })

    // 顶部文字
    initMarquee({
        wrap: ".top-marquee",
        track: ".marquee-track",
        group: ".marquee-group",
        speed: 1
    });

    //box2
    $('.b2_cart button').click(function (e) {
        e.preventDefault();
        e.stopPropagation()
    })

    $('.box3i_icon div').click(function(){
        var index = $(this).index()
        $(this).addClass('box3Active1').siblings().removeClass('box3Active1')
        if(wFlag){
            $('.box3_right .box3_img div').eq(index).addClass('box3Active').siblings().removeClass('box3Active')
        }else{
            $('.Mbox3_right .box3_img div').eq(index).addClass('box3Active').siblings().removeClass('box3Active')
        }
    })

    $('.b2_colors div').click(function(){
        var index = $(this).index()
        $(this).addClass("box3Active1").siblings().removeClass("box3Active1");
        $(this).closest('.box2_item').find('.b2_img div img').eq(index).css({opacity:1}).siblings().css({opacity:0});
    }) 

    //box4
    new Swiper('.box4Swiper', {
        autoplay: true,
        slidesPerView: wFlag ? 2 : 1,
        navigation: {
            nextEl: '.box4Swiper-button-next',
            prevEl: '.box4Swiper-button-prev',
        }
    })

    // logo
    initMarquee({
        wrap: ".logo-marquee",
        track: ".logo-track",
        group: ".logo-group",
        speed: 0.5
    });

    //box5
    new Swiper('.box5Swiper', {
        autoplay: true,
        pagination: {
            el: '.box5Swiper-pagination',
            clickable: true,
        }
    })

    //box6
    new Swiper('.box6Swiper', {
        autoplay: true,
        slidesPerView: wFlag ? 3 : 1,
        navigation: {
            nextEl: '.box6Swiper-button-next',
            prevEl: '.box6Swiper-button-prev',
        },
        on:{
            slideChangeTransitionEnd: function () {
                if (wFlag) return;
            
                var $swiper = $('.box6Swiper');
            
                $swiper.find('.box6_item video').each(function () {
                    this.pause();
                    // this.currentTime = 0;
                });
            
                var activeVideo = $swiper.find('.swiper-slide-active video')[0];
            
                if (activeVideo) {
                    activeVideo.play().catch(function () {
                        // 浏览器可能因为自动播放策略阻止播放
                    });
                }
            }
        }
    })
    if(wFlag){
        $('.box6_item').hover(function(){
            $(this).find('video')[0].play()
        },function(){
            $(this).find('video')[0].pause()
        })
    }

    new Swiper('.box6Swiper1', {
        //autoplay: true,
        slidesPerView:1,
        navigation: {
            nextEl: '.box6Swiper1-button-next',
            prevEl: '.box6Swiper1-button-prev',
        }
    })
    $(".box6_name").each(function () {
        var fullName = $(this).children("div").eq(1).text().trim(); 
        // 例如 "Alexander J."
    
        // 拆分名字（按空格）
        var parts = fullName.split(" ");
    
        var firstInitial = parts[0] ? parts[0].charAt(0).toUpperCase() : "";
        var lastInitial = parts[1] ? parts[1].charAt(0).toUpperCase() : "";
    
        var initials = firstInitial + lastInitial; // AJ
    
        // 填入第一个 div
        $(this).children("div").eq(0).text(initials);
    });

    //box7
    new Swiper('.box7Swiper', {
        autoplay: true,
        navigation: {
            nextEl: '.box7Swiper-button-next',
            prevEl: '.box7Swiper-button-prev',
        },
    })
})